import React, { Suspense, useEffect, useState, lazy } from "react";
import { useDispatch, useSelector } from "react-redux";
import QueryString from "query-string";

import { Box, CircularProgress } from "@material-ui/core";

import { useStyles } from "./style";

import ListingLayout from "../../Components/UI/ListingLayout";

import {
  generateCard,
  getBackView,
} from "../../Stores/SlickCareProfiles/actions";
import { setCardView } from "../../Stores/Filter/actions";
import { cardStyleConfig, cardStyleList } from "../../Data/cardFilters";
import { toggleInstruction } from "../../Stores/Reviews/actions";

const InstructionModal = lazy(() => import("./InstructionModal"));

const ReviewPoster = () => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const { activeLocation, isGenerating } = useSelector(
    (state) => state.SlickCareProfilesReducer
  );
  const { cardFilters, cardView } = useSelector((state) => state.FilterReducer);
  const query = QueryString.parse(window.location.search);

  const [pdfString, setPdfString] = useState("");
  const [pdfBackString, setPdfBackString] = useState("");

  const [loader, setLoader] = useState(true);

  let loading = loader || isGenerating;

  const onSuccess = (blobPDF) => {
    let reader = new FileReader();
    reader.readAsDataURL(blobPDF);
    reader.onloadend = () => {
      let base64String = reader.result;
      setPdfString(base64String);
    };
  };

  const onBackSuccess = (blobPDF) => {
    let reader = new FileReader();
    reader.readAsDataURL(blobPDF);
    reader.onloadend = () => {
      let base64String = reader.result;
      setPdfBackString(base64String);
    };
  };

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      if (cardView === "Front View") {
        setPdfString("");

        const bodyFormData = new FormData();
        bodyFormData.append("location_id", query?.location_id ?? "");
        bodyFormData.append("strapline", cardFilters?.strapline ?? "");
        bodyFormData.append(
          "has_custom_logo",
          cardFilters?.has_custom_logo ?? false
        );
        bodyFormData.append("custom_logo", cardFilters?.custom_logo ?? "");

        bodyFormData.append("bg_type", cardFilters.bg_type ?? "");

        bodyFormData.append(
          "bg_color",
          cardFilters.bg_type === "solid"
            ? cardFilters.bg_color
            : cardStyleConfig[cardFilters?.style_id]?.bg_color ?? ""
        );
        bodyFormData.append(
          "box_color",
          cardFilters.bg_type === "solid"
            ? cardFilters.box_color
            : cardStyleConfig[cardFilters?.style_id]?.box_color ?? ""
        );

        bodyFormData.append(
          "text_color",
          cardStyleConfig[cardFilters?.style_id]?.text_color ?? ""
        );
        bodyFormData.append(
          "bg_path",
          cardStyleConfig[cardFilters?.style_id]?.bg_path ?? ""
        );

        dispatch(
          generateCard(
            {
              data: bodyFormData,
              type: "Card",
              title: activeLocation?.title,
            },
            onSuccess
          )
        );
        setLoader(false);
      }
      if (cardView === "Back View") {
        setPdfBackString("");
        dispatch(getBackView({}, onBackSuccess));
        setLoader(false);
      }
    }, 1000);

    return () => clearTimeout(delayDebounceFn);
  }, [cardFilters, activeLocation, cardView]);

  return (
    <>
      <ListingLayout
        title="Poster"
        item="ENQUIRIES"
        hideAdd={true}
        hasFilter={false}
        showLocationToggle={true}
        hasListFilter={true}
        listfilter={[{ label: "Front View" }, { label: "Back View" }]}
        activeListFilter={cardView}
        onListFilterClick={(args) => {
          dispatch(setCardView(args));
          setLoader(true);
          setPdfString("");
          setPdfBackString("");
        }}
        hasCardActions={true}
        onCardAction={() => {
          dispatch(toggleInstruction({ open: true }));
        }}
        cardActionTitle={`Order Cards`}
      >
        <Box>
          {loading ? (
            <Box className={classes.loaderWrap}>
              <CircularProgress size="40px" />
            </Box>
          ) : (
            <embed
              src={
                cardView === "Front View"
                  ? `${pdfString}`
                  : cardView === "Back View"
                  ? `${pdfBackString}`
                  : ""
              }
              width={"100%"}
              height={800}
            />
          )}
        </Box>
      </ListingLayout>
      <Suspense fallback={null}>
        <InstructionModal />
      </Suspense>
    </>
  );
};

export default ReviewPoster;
